export * from "./product-card";
export { ProductCard as default } from "./product-card";
